import axios from "axios";
import { getRuntimeConfig } from "config/runtimeConfig";

const AttachTokenFunc = async (config: any) => {
  const token = sessionStorage.getItem("jwt_token");
  if (token) {
    config.headers = {
      Authorization: `Bearer ${token}`,
    };
  }
  return config;
};

const commonApi = axios.create({
  baseURL: process.env.REACT_APP_COMMON_API,
  validateStatus: (status) => status >= 200 && status < 500,
});
commonApi.interceptors.request.use(AttachTokenFunc, (error) => Promise.reject(error));

const aiChatApi = axios.create({
  baseURL: process.env.REACT_APP_AI_API,
  validateStatus: (status) => status >= 200 && status < 500,
});
aiChatApi.interceptors.request.use(AttachTokenFunc, (error) => Promise.reject(error));

const energyApi = axios.create({
  validateStatus: (status) => status >= 200 && status < 500,
});

let energyApiInitialized = false;

energyApi.interceptors.request.use(
  (config) => {
    if (!energyApiInitialized) {
      const runtimeConfig = getRuntimeConfig();
      energyApi.defaults.baseURL = runtimeConfig.REACT_APP_TSDCD_API;
      energyApiInitialized = true;
    }
    return AttachTokenFunc(config);
  },
  (error) => Promise.reject(error)
);

export { commonApi, energyApi, aiChatApi };



